import { render, staticRenderFns } from "./ProposalPreviewMitrex.vue?vue&type=template&id=2eb78f48&scoped=true"
import script from "./ProposalPreviewMitrex.vue?vue&type=script&lang=js"
export * from "./ProposalPreviewMitrex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb78f48",
  null
  
)

export default component.exports